import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CountryCode, addressToString, validateAddress, } from '@debbie/common/dist';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import AddressFinder from './AddressFinder';
import Button from './Button';
import { Row, Col } from './Grid';
import { Edit } from './Icons';
import Input from './Input';
import Well from './Well';
import { ButtonGroup, Modal } from '.';
const countryCodeLangMap = {
    [CountryCode.GL]: 'Grønland',
    [CountryCode.DK]: 'Danmark',
};
var EditingStates;
(function (EditingStates) {
    EditingStates["no"] = "no";
    EditingStates["search"] = "search";
})(EditingStates || (EditingStates = {}));
const AddressInput = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const [editing, setEditing] = useState(EditingStates.no);
    const [focusNoEditInput, setFocusNoEditInput] = useState(false);
    const [editAddressModalOpen, setEditAddressModalOpen] = useState(false);
    const [address, setAddress] = useState({
        address: '',
        zipcode: '',
        city: '',
    });
    const noSearch = (_a = (tenant === null || tenant === void 0 ? void 0 : tenant.countryCode) != CountryCode.DK) !== null && _a !== void 0 ? _a : false;
    const noEditRef = useRef(null);
    useEffect(() => {
        if (props.address && props.address !== address) {
            setAddress({
                address: props.address.address,
                coAddress: props.address.coAddress,
                city: props.address.city,
                zipcode: props.address.zipcode,
                country: props.address.country,
            });
        }
    }, [props.address]);
    const changeState = (state) => {
        setEditing(state);
        if (props.notUpdateOnEditingStateChange)
            return;
    };
    const submitAddress = (address) => {
        props.onChange && props.onChange(address);
        setEditing(EditingStates.no);
        if (!noSearch) {
            setFocusNoEditInput(true);
        }
    };
    useEffect(() => {
        var _a;
        if (focusNoEditInput) {
            if (noEditRef.current) {
                // @ts-ignore
                (_a = noEditRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    }, [focusNoEditInput]);
    const formatAddress = (r) => ({
        address: `${r.data.vejnavn} ${r.data.husnr}${r.data.etage || r.data.dør
            ? `, ${r.data.etage ? `${r.data.etage}.` : ''}${r.data.dør ? ` ${r.data.dør}` : ''}`
            : ''}`,
        coAddress: null,
        city: r.data.postnrnavn,
        zipcode: r.data.postnr,
        country: 'Danmark',
    });
    return (React.createElement(React.Fragment, null,
        (() => {
            switch (editing) {
                case 'no':
                    return (React.createElement("div", { className: props.className, onClick: props.onClick },
                        React.createElement(Input, { onClick: () => changeState(EditingStates.search), placeholder: props.placeholder || lang.inputs.address, onChange: () => { }, value: props.address && props.address.address
                                ? addressToString(props.address)
                                : '', onFocus: (e) => {
                                if (focusNoEditInput) {
                                    setFocusNoEditInput(false);
                                }
                                else if (noSearch) {
                                    e.preventDefault();
                                    setEditAddressModalOpen(true);
                                }
                                else {
                                    changeState(EditingStates.search);
                                }
                            }, inputRef: noEditRef, onKeyDown: (e) => {
                                if (![9, 16].includes(e.keyCode))
                                    changeState(EditingStates.search);
                            } })));
                case 'search':
                    return (React.createElement("div", { className: props.className, onClick: props.onClick },
                        React.createElement(AddressFinder, { button: {
                                value: React.createElement(Edit, null),
                                onClick: () => {
                                    setEditAddressModalOpen(!editAddressModalOpen);
                                },
                                tabIndex: -1,
                            }, autofocus: props.autofocus || true, onSelect: (result) => {
                                const address = formatAddress(result);
                                submitAddress(address);
                            }, onBlur: () => {
                                setTimeout(() => {
                                    changeState(EditingStates.no);
                                }, 200);
                            } })));
                default:
                    return null;
            }
        })(),
        editAddressModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setEditAddressModalOpen(!editAddressModalOpen), header: props.placeholder || lang.inputs.address },
            React.createElement("div", { className: props.className, onClick: props.onClick },
                React.createElement(Well, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { width: "12" },
                            React.createElement(Input, { autofocus: true, placeholder: lang.inputs.address, value: (address && address.address) || '', onChange: (e) => setAddress((addr) => {
                                    var _a, _b;
                                    return Object.assign(Object.assign({}, address), { address: e.target.value, country: (_b = (_a = addr.country) !== null && _a !== void 0 ? _a : (tenant &&
                                            countryCodeLangMap[tenant.countryCode])) !== null && _b !== void 0 ? _b : 'Danmark' });
                                }) })),
                        React.createElement(Col, { width: "12" },
                            React.createElement(Input, { placeholder: lang.inputs.co, value: (address && address.coAddress) || '', onChange: (e) => setAddress(Object.assign(Object.assign({}, address), { coAddress: e.target.value && e.target.value != ''
                                        ? e.target.value
                                        : null })) })),
                        React.createElement(Col, { width: "4" },
                            React.createElement(Input, { placeholder: lang.inputs.zipcode, value: (address && address.zipcode) || '', onChange: (e) => setAddress(Object.assign(Object.assign({}, address), { zipcode: e.target.value })) })),
                        React.createElement(Col, { width: "8" },
                            React.createElement(Input, { placeholder: lang.inputs.city, value: (address && address.city) || '', onChange: (e) => setAddress(Object.assign(Object.assign({}, address), { city: e.target.value })) })),
                        React.createElement(Col, { width: "12" },
                            React.createElement(Input, { placeholder: lang.inputs.country, value: (address && address.country) || '', onChange: (e) => setAddress(Object.assign(Object.assign({}, address), { country: e.target.value })) })),
                        React.createElement(Col, { width: "12" },
                            React.createElement("br", null),
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "small", onClick: () => {
                                        if (address && address.address)
                                            submitAddress(address);
                                        setEditAddressModalOpen(false);
                                    }, disabled: !validateAddress(address) }, lang.inputs.done),
                                React.createElement(Button, { size: "small", theme: "secondary", onClick: () => {
                                        submitAddress(null);
                                        setEditAddressModalOpen(false);
                                    } }, lang.inputs.removeAddress))))))))));
};
export default AddressInput;
//# sourceMappingURL=AddressInput.js.map